import { mask } from 'superstruct';

import { AddGMBTemplateDto } from './gmb-template.dto';

export const DefaultGMBTemplateValuesDto = () =>
	mask(
		{
			name: 'GMB :: Promo :: Template name',
			archived: false,

			// Post fields
			postType: 'STANDARD',
			languageCode: 'en-US',
			ctaType: 'LEARN_MORE',
			ctaUrl: '',

			redeemOnlineUrl: '',
			couponCode: '',
			termsConditions: '',

			title: 'Post title',
			summary: 'Post summary',
			startDate: '',
			endDate: '',
		} satisfies AddGMBTemplateDto,
		AddGMBTemplateDto
	);

export const CreateGMBTemplateValuesDto = () => ({
	name: 'GMB :: Promo :: Template name',
	archived: false,

	// Post fields
	postType: 'STANDARD',
	languageCode: 'en-US',
	ctaType: 'LEARN_MORE',
	ctaUrl: '',

	redeemOnlineUrl: '',
	couponCode: '',
	termsConditions: '',

	title: 'Post title',
	summary: 'Post summary',
	startDate: '',
	endDate: '',
});
